import Vue from "vue";
import Router from "vue-router";

// import HomeSystem from "./views/WebSystem/Home.vue";
import HomePage from "@/views/WebSite/Home.vue";
// import HomePage from "@/views/WebSite/Login/Login.vue";

// Creador de contenido --->
Vue.use(Router);
const router = new Router({
 	mode: "history",
  	base: "/",

  	routes: [
    // ////////////////////////////////////////
    //---------------  MAIN --------------------
    {
    	path: "*",
      	redirect: "/home", 
    },
      
    {
		path: "/home",
		name: "home",
		component:  HomePage,
		meta: {
			autentificado: false,
			layout: "webSite_layout",
			breadCrumb: "INICIO",
		},
    },

	/*
    {
      	path: "/login",
      	name: "login",
      
      	component: () => import("./views/WebSite/Login/Login.vue"),
		meta: {
			layout: "login_layout",
			breadCrumb: "LOGIN",
		},
    },
	
	*/
	{
		// router pagina administracion del colegio
		path: "/kw",
		name: "kwsoluciones",
	
		component: () => import("./views/WebSite/Login/Login.vue"),
	  meta: {
		  layout: "login_layout",
		  breadCrumb: "LOGIN",
	  },
  },
/*

    {
		path: "/homeSystem",
		name: "home system",
		component:  HomeSystem,
		meta: {
			autentificado: false,
			layout: "webSystem_layout",
			breadCrumb: "INICIO",
		},
    },

*/

    //--------------- FIN  MAIN --------------------

    //   ////////////////////////   //
    //    SISTEMA CONFIGURACION     //

	/*
    {
		path: '/perfil',
		name: 'perfiles',
		component: () => import('@/views/WebSystem/Sistema/Perfil/PerfilUsuario.vue'),
		meta: {
			autentificado: true,
			layout: 'webSystem_layout',
			breadCrumb: "MÓDULO CONFIGURACION SISTEMA / PERFIL",
		}
  },


{
    path: '/usuario',
    name: 'usuarios',
    component: () => import('@/views/WebSystem/Sistema/Usuario/Usuario.vue'),
    meta: {
        autentificado: true,
        layout: 'webSystem_layout',
        breadCrumb: "MÓDULO CONFIGURACION SISTEMA / USUARIOS"
    }
},

{
	path: '/sisConfiguracion',
	name: 'sistemaConfiguracion',
	component: () => import('@/views/WebSystem/Sistema/Configuracion/ControlSistemaTab.vue'),
	meta: {
		autentificado: true,
		layout: 'webSystem_layout',
		breadCrumb: "MÓDULO CONFIGURACION SISTEMA / CONFIGURACIÓN",
	}
},  

*/

//--------------- FIN   MODULO GENERAL--------------------


// /////////////////////////////////////////////////////////
//  ----  START Administración de la pagina web web  ---- //



//--------------- FIN MODULO DE SISTEMA CONFIGURACION --------------------

// /////////////////////////////////////////////////////////
//  ----  START Administración de la pagina web web  ---- //








	// ////////////////////////////////////////////
	//--------------- WEB MASTER --------------------
  


  
      //--------------- END  WEBMASTER  --------------------



  ],
});

router.beforeEach((to, from, next) => {
	if (to.meta.autentificado && !sessionStorage.autentificado) {
		next("login");
	} else {
		next();
	}
});

export default router;
